module.exports = __webpack_public_path__ + "assets/logo-white@2x.8cb7c951.png";